$(document).ready(function () {
  // Global variants
  let winW = window.innerWidth;
  const setWinW = () => {
    winW = window.innerWidth;
  }
  window.addEventListener('resize', setWinW);





  // Fix-up nav when it touched top
  if ($("div").hasClass("auto_fix_nav")) {
    const navFix = () => {
      let $n = $(".auto_fix_nav"), $nc = $n.children().eq(0), h = $(".header_height_box").height(), nt = $n.offset().top,
        $c = $(".auto_fix_target_container"), ch = $c.height(), ct = $c.offset().top, cd = 0;

      // Set-up edge for unfixed
      if ($("div").hasClass("blog_nav") || window.innerWidth > 1023) {
        cd = (ct - window.innerHeight) * - 1;
      } else {
        cd = ((ct - window.innerHeight) * - 1) - window.innerHeight;
      }

      // Calculate displacement margin top
      if (window.innerWidth < 1024) {
        h = $(".header_height_box").height();
        ct = ch - cd - h;
      } else {
        if ($n.hasClass("nav_no_margin")){
          h = $(".header_height_box").height();
        } else {
          h = $(".header_height_box").height() + 36;
        }
        ct = ch + h - window.innerHeight;
        if (ct < 0) { ct = 0 };
      }

      // Change header's fixed status when scrolling
      if (h >= nt && ch >= cd) {
        $nc.addClass("fixed z-20");
        $nc.css({ "top": h, "width": $n.width(), "max-width": "unset", "margin-top": 0 });
      } else if (h >= nt && ch <= cd && window.innerWidth > 1023) {
        $nc.removeClass("fixed z-20");
        $nc.css({ "margin-top": ct });
      } else {
        $nc.removeClass("fixed z-20");
        $nc.removeAttr("style");
      }
    }
    navFix();

    document.getElementById("MainContent").addEventListener("scroll", navFix);
    window.addEventListener("resize", navFix);
  }





  // Blog side nav
  if ($("div").hasClass("blog_nav") && $("span").hasClass("no_nav")) {
    // Set invisible on blog nav
    $(".blog_nav_container").addClass("hidden");
    $(".blog_nav_button").css("display", "none");

  } else if ($("div").hasClass("blog_nav") && !$("span").hasClass("no_nav")){
    // Set-up variables
    let c = ".customized_textarea", $c = $(c), $cd = $(".customized_textarea div"), h = "h1, h2, h3, h4, h5, h6, h7", hh = [], hhh = [], f = 0, blogNav = [];

    // Auto generate side nav contents
    if ($c.find(h).length != 0) {
      let i, ii = 0, iii = 1, e = [];
      hh.push($c.find(h));
      hhh = hh[0];

      // Set-up nav
      for (i = 0; i < hhh.length; i++) {
        $(".blog_nav div").append('<p class="' + hhh[i].tagName.toLowerCase() + '"><a href="#nav_' + i + '">' + hhh[i].innerHTML + '</a></p>');
        $cd.children(h).eq(i).attr("id", "nav_" + i);
        blogNav.push(hhh[i].tagName);
      }

      // Add numbers on nav
      for (i = 0; i < blogNav.length; i++) {
        let a = blogNav[i].slice(1, 2), b = blogNav[0].slice(1, 2);

        if (a == b) {
          ii = ii + 1;
          e.push(ii);
        } else if (a > b) {
          let d = blogNav[i - 1].slice(1, 2);
          if (a == d) {
            f = Number(e[i - 1].slice(-1)) + 1;
            e.push(e[i - 1].slice(0, e[i - 1].length - 1) + f);
          } else if (a > d) {
            e.push(e[i - 1] + "." + iii);
          } else if (a < d) {
            f = Number(e[i - 2].slice(-1)) + 1;
            e.push(e[i - 2].slice(0, e[i - 2].length - 1) + f);
          }
        }
        $(".blog_nav div").children().eq(i).prepend('<del>' + e[i] + '</del>');
        $(".blog_nav_container").removeClass("hidden");
      }
    }

    // When window width < 1024 and nav button has clicked
    if (winW < 1024) {
      $(".blog_nav_button, .blog_nav div p").click(function () {
        if ($(".blog_nav_container").hasClass("scale-0")) {
          $(".blog_nav_button").addClass("actived");
          $(".blog_nav").removeClass("unfocus");
          $(".blog_nav").addClass("focus");
          $(".blog_nav_container").removeClass("scale-0");
        } else {
          $(".blog_nav_button").removeClass("actived");
          $(".blog_nav").removeClass("focus");
          $(".blog_nav").addClass("unfocus");
          $(".blog_nav_container").addClass("scale-0")
        }
      })
    }




    // Change state for blog side nav responsive
    const blogNavOnMobile = () => {
      if (window.innerWidth < 1024 && !$(".blog_nav").hasClass("focus")) {
        $(".blog_nav_container").addClass("scale-0");
      } else {
        $(".blog_nav_container").removeClass("scale-0");
        $(".blog_nav").removeClass("unfocus");
      }
    }
    blogNavOnMobile();



    // Blog Status
    function blogNavStatus() {
      // Change readed status on blog's navigation
      for (let i = 0; i < blogNav.length - 1; i++) {
        let a = $cd.children(h).eq(i), b = $cd.children(h).eq(i + 1), l = blogNav.length - 1;
        if (a.offset().top <= 120 && a.offset().top <= b.offset().top) {
          a.addClass("readed");
          $(".blog_nav div").children().eq(i).addClass("readed");
        } else {
          a.removeClass("readed");
          $(".blog_nav div").children().eq(i).removeClass("readed");
        }
      }
    }
    blogNavStatus();



    // Function working when document loaded and window resized
    window.addEventListener('resize', blogNavOnMobile);
    window.addEventListener('resize', blogNavStatus);
    document.getElementById("MainContent").addEventListener("scroll", blogNavStatus);
  }



  // Display blog cover when page loaded
  if ($('.customized_textarea div img:first-child').hasClass('blog_post_cover')) {
    $('.customized_textarea div img.blog_post_cover').prependTo('.blog_container');
    $('.blog_container img.blog_post_cover').addClass('w-full mb-9 object-cover object-center max-h-60 lg:px-0 lg:max-h-90 lg:rounded');
    $('.blog_container img.blog_post_cover').removeClass('hidden');
    $('.customized_textarea div img.blog_post_cover').remove();
  }
})